





































































/** @format */

import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { cloneDeep } from 'lodash';
import { trim } from '@/utils/validators';
import { PLATE_PROVINCE_STRING } from '@/components/plate-input/constant';
export interface IFileName {
  label: string;
  value: string;
  children: string;
}
export interface IForm {
  name: string;
  space_type: string;
  desc: string;
}

@Component({})
export default class AddEditModal extends Vue {
  @Prop()
  data!: any;

  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;

  @Prop({ type: Boolean, default: false })
  visible!: boolean;

  trim = trim;
  plateRegExp = new RegExp(`^[${PLATE_PROVINCE_STRING}][A-Z]?$`);

  confirmLoading: boolean = false;
  labelCol = { span: 6 };
  wrapperCol = { span: 15 };

  fieldNames: IFileName = {
    label: 'name',
    value: 'id',
    children: 'children'
  };
  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }

  form: any = null;
  desc: string = '';
  spaceType: string = 'house';
  mounted() {
    this.init();
  }

  init() {
    if (this.isEdit) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const { name, space_type, desc } = this.data;
          this.spaceType = space_type || 'room';
          return {
            name: this.$form.createFormField({
              value: name
            }),
            space_type: this.$form.createFormField({
              value: space_type
            }),
            desc: this.$form.createFormField({
              value: desc
            })
          };
        }
      });
    } else {
      this.form = this.$form.createForm(this);
    }
  }

  async onSubmit() {
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        if (this.isEdit) {
          this.onEdit(values);
        } else {
          this.onAdd(values);
        }
      }
    });
  }
  async onAdd(values: IForm) {
    try {
      // let { name, space_type, desc } = values
      // let params = {
      //   name,
      //   space_type,
      //   desc,
      //   type: 2, // 1 管理区域, 2网格
      // }
      // let {
      //   data: { data },
      // } = await addSpaceGroup(params)
      this.$message.success('新增成功');
      this.form.resetFields();
      this.$emit('create');
    } catch (e) {
      console.log(e);
    }
  }
  async onEdit(values: IForm) {
    try {
      // let { name, desc } = values
      // let params = {
      //   name,
      //   desc,
      // }
      // let {
      //   data: { data },
      // } = await editSpaceGroup(this.data.id, params)
      this.$message.success('编辑成功');
      this.form.resetFields();
      this.$emit('create');
    } catch (e) {
      console.log(e);
    }
  }
}
